import {isValid} from 'validators/number-validator';

export const getBarY = (barHeight, verticalSpacing, index) => {
  if (isValid(barHeight) && isValid(verticalSpacing) && isValid(index)) {
    return Math.ceil((barHeight + verticalSpacing) * index);
  }
  return 0;
};

export const getCenter = (value) => {
  if (isValid(value) && value > 0) {
    return Math.round(value / 2);
  }
  return 0;
};

export const getChartWidth = (width, svgNode) => {
  if (isValid(width) && width > 0) {
    return Math.ceil(width);
  }
  if (svgNode) {
    const parentWidth = svgNode.parentNode.clientWidth;
    if (isValid(parentWidth) && parentWidth > 0) {
      return Math.floor(parentWidth);
    }
  }
  return 0;
};

export const getColumnCenterX = (tickWidth, index) => {
  if (isValid(tickWidth) && isValid(index)) {
    return Math.floor(tickWidth * index + tickWidth / 2);
  }
  return 0;
};

export const getColumnHeight = (zeroY, scaleY, value) => {
  if (
    isValid(zeroY) &&
    isValid(value) &&
    scaleY &&
    scaleY.domain() &&
    scaleY.range()
  ) {
    const columnHeight = Math.round(zeroY - scaleY(Math.abs(value)));
    return columnHeight > 0 ? columnHeight : 0;
  }
  return 0;
};

export const getColumnWidth = (tickWidth, columnSpacing, offset = 0) => {
  if (isValid(tickWidth) && isValid(columnSpacing) && isValid(offset)) {
    const columnWidth = tickWidth - columnSpacing + offset;
    return columnWidth > 0 ? columnWidth : 0;
  }
  return 0;
};

export const getColumnX = (tickWidth, index) => {
  if (isValid(tickWidth) && isValid(index)) {
    return Math.floor(tickWidth * index);
  }
  return 0;
};

export const getColumnY = (scale, value) => {
  if (scale && isValid(value)) {
    return value >= 0 ? Math.round(scale(value)) : Math.round(scale(0));
  }
  return 0;
};

export const getContentWidth = (width, left, right) => {
  return Math.ceil(width - left - right);
};

export const getContentX = (gutters) => {
  return Math.ceil(gutters.left);
};

export const getCoordsFromTranslate = (translate) => {
  if (translate) {
    const regExp = /\(([^)]+)\)/;
    const matches = regExp.exec(translate);
    if (matches) {
      const coords = matches[1].split(',');
      const x = parseFloat(coords[0]);
      const y = parseFloat(coords[1]);
      return [isValid(x) ? x : 0, isValid(y) ? y : 0];
    }
  }
  return [];
};

export const getCx = (x) => {
  if (isValid(x)) {
    return Math.floor(x);
  }
  return 0;
};

export const getCy = (y) => {
  if (isValid(y)) {
    return Math.round(y);
  }
  return 0;
};

export const getFullWidthX = (width, dataLength, index) => {
  return (width / dataLength) * index;
};

export const getGutters = (gutters) => {
  if (typeof gutters === 'number') {
    const amount = isValid(gutters) ? gutters : 0;
    return {
      bottom: amount,
      left: amount,
      right: amount,
      top: amount,
    };
  }
  if (typeof gutters === 'object') {
    return {
      bottom: gutters.bottom || 0,
      left: gutters.left || 0,
      right: gutters.right || 0,
      top: gutters.top || 0,
    };
  }
};

export const getHeight = (height) => {
  if (isValid(height)) {
    return height >= 0 ? height : 0;
  }
  return 0;
};

export const getStepY = (scale, value) => {
  if (typeof scale === 'function' && isValid(value)) {
    return Math.round(scale(value));
  }
  return 0;
};

export const getTickY = (scale, tick) => {
  if (typeof scale === 'function' && isValid(tick)) {
    return scale(tick);
  }
  return 0;
};

export const getWidth = (width) => {
  if (isValid(width)) {
    return width >= 0 ? width : 0;
  }
  return 0;
};
